import { routes } from "@/routes/routes";
import { RouteName } from "@/routes/routes.types";

/**
 * Array of routeNames from routes object
 */
export const routeNames = Object.keys(routes) as RouteName[];
